import React from "react";
import { Layout, Typography, Row, Col, Divider, ConfigProvider } from "antd";
import { Image } from 'antd';
import { BreadCrumbs } from "../../Components/Layout/BreadCrumbs";
const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;


const MemberSystemSafety: React.FC = () => {
    return (
        <Layout style={{ background: "#fff" }}>
            <Content>
                <ConfigProvider
                    theme={{
                        components: {
                            Typography: {
                                fontSize: 18,
                                lineHeight: 1.7,
                            },
                        },
                    }}
                >
                    <Typography>

                        <div className="article-block">
                            <div className="article-inner">
                                <div
                                    style={{
                                        background: "#f0f5ff",
                                        padding: "80px 24px",
                                        borderRadius: 12,
                                        marginBottom: 48,
                                    }}
                                >
                                    <Row gutter={[32, 32]} align="middle">
                                        <Col xs={24} md={14}>

                                            <BreadCrumbs currentName="GDPR och säkerhet" />

                                            <Title style={{ fontSize: 42, fontWeight: 700, marginBottom: 24 }}>
                                                Trygg hantering av personuppgifter – GDPR och säkerhet i OneFront360
                                            </Title>

                                            <Paragraph>
                                                Att hantera personuppgifter på ett säkert och lagenligt sätt är avgörande för alla föreningar. Med OneFront360 får du ett medlemssystem som är byggt med <Text strong>GDPR och informationssäkerhet</Text> i fokus – så att du kan känna dig trygg med hur medlemmarnas data behandlas.
                                            </Paragraph>

                                        </Col>

                                        <Col xs={24} md={10}>
                                            <Image
                                                src={require('../../Images/Articles/sakert-medlemsregister.png')}
                                                preview={false}
                                                style={{ borderRadius: 12, width: "100%" }}
                                            />
                                        </Col>
                                    </Row>
                                </div>


                            </div></div>

                        <div className="article-grey-block">
                            <div className="article-inner">
                                <Title level={2}>GDPR – vad innebär det för föreningar?</Title>
                                <Paragraph>
                                    Dataskyddsförordningen (GDPR) gäller alla organisationer som behandlar personuppgifter – även ideella föreningar. Det innebär att du som föreningsansvarig har ett juridiskt ansvar att:
                                </Paragraph>
                                <ul>
                                    <li><Text>Samla in uppgifter för tydliga och berättigade ändamål</Text></li>
                                    <li><Text>Begränsa mängden data till det som är relevant</Text></li>
                                    <li><Text>Skydda uppgifterna från obehörig åtkomst</Text></li>
                                    <li><Text>Informera medlemmar om hur deras data används</Text></li>
                                    <li><Text>Radera eller rätta uppgifter vid begäran</Text></li>
                                </ul>
                                <Paragraph>
                                    OneFront360 hjälper dig att följa dessa principer genom inbyggda funktioner för dataskydd och transparens.
                                </Paragraph>

                                <Title level={3}>Så hjälper OneFront360 dig att följa GDPR</Title>
                                <Paragraph>
                                    Med OneFront360 får du verktyg som gör det enkelt att hantera GDPR:
                                </Paragraph>
                                <ul>
                                    <li><Text>Exportera personuppgifter vid begäran</Text></li>
                                    <li><Text>Radera medlemmar enligt rätt till radering</Text></li>
                                    <li><Text>Visa tydlig information om databehandling</Text></li>
                                    <li><Text>Logga samtycken och kommunikation</Text></li>
                                </ul>
                                <Paragraph>
                                    Du får en trygg och transparent hantering som stärker medlemmarnas förtroende.
                                </Paragraph>

                            </div>
                        </div>
                        <Divider />

                        <div className="article-block">
                            <div className="article-inner">

                                <Title level={2}>Säkerhet i OneFront360 – så skyddas dina data</Title>
                                <Paragraph>
                                    Systemet är byggt med modern teknik och säkerhetsrutiner som skyddar både medlemmarnas personuppgifter och föreningens interna information.
                                </Paragraph>
                                <ul>
                                    <li><Text>Krypterad datalagring och överföring</Text></li>
                                    <li><Text>Behörighetsstyrning – kontroll över vem som ser vad</Text></li>
                                    <li><Text>Automatiska loggar och spårbarhet</Text></li>
                                    <li><Text>Tvåfaktorsautentisering för administratörer</Text></li>
                                    <li><Text>Regelbundna säkerhetsuppdateringar</Text></li>
                                </ul>
                                <Paragraph>
                                    All data lagras inom EU och följer gällande dataskyddsregler.
                                </Paragraph>

                            </div></div>

                        <div className="article-grey-block">
                            <div className="article-inner">

                                <Title level={2}>Sammanfattning – trygghet för både förening och medlem</Title>
                                <Paragraph>
                                    OneFront360 är mer än ett medlemssystem – det är en plattform som hjälper dig att följa lagen, skydda medlemmarnas integritet och skapa en säker digital miljö. Med inbyggt stöd för GDPR och starka säkerhetsfunktioner är du alltid ett steg före.
                                </Paragraph>

                            </div></div>



                    </Typography>
                </ConfigProvider>
            </Content >
        </Layout >
    );
};

export default MemberSystemSafety;
